module.exports = __webpack_public_path__ + "assets/img/8_1726_big.0492258d.jpg";